export const RetryConditionsEnum ={
    UntilCheck: 1,
    OverAttempts: 2,
    AlwaysAllowRetries: 3
}